import { render, staticRenderFns } from "./classical-material-breakdown.vue?vue&type=template&id=a07249fa"
import script from "./classical-material-breakdown.vue?vue&type=script&lang=js"
export * from "./classical-material-breakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports